import styles from "./MainAbout.module.css"
import image from "../../assets/images/about.webp"

const MainAbout =()=>{
    return (
      <section className={`height ${styles.main}`} id="about-section">
        <div className={styles.content}>
          <h2 className="h2-bold">About</h2>
          <p className="h4-medium">
            High-quality distortion grid shoots typically require 1–3 hours with a film crew, plus costly rental gear. Yet the grids often stay buried in project archives and never get reused — or they arrive too late for tracking — so <strong>matchmove artists end up spending significant time</strong> adjusting lens parameters from scratch.
          </p>
          <p className="h4-medium">
            To solve this, we’ve assembled a growing library of <strong>distortion grids for popular camera-and-lens combinations</strong>, alongside rare assets added weekly with support from the global community.
          </p>
          <p className="h4-medium">
            Save time, protect your clients’ budget, and stay confident in the result.
          </p>
        </div>
        <div className={styles.imgcont}>
          <img src={image} alt="about" />
        </div>
      </section>
    );
}

export default MainAbout